import React from 'react';

const Unauthorized: React.FC = () => {
  return <div>401 - Unauthorized Access</div>;
};

export default Unauthorized;